import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setCheckOutConfirmIsOpen } from 'redux/checkOutConfirmInfoSlice'
import Spinner from 'components/Spinner';
import FloorCard from '../FloorCard'
import EighthFloor from '../FloorPlan/floors/EighthFloor'
import NinthFloor from '../FloorPlan/floors/NinthFloor'
import TenthFloor from '../FloorPlan/floors/TenthFloor'
import Legend from '../Legend'
import ModalCheckOutConfirm from "screens/ModalCheckOutConfirm";
import { useQuery } from '@apollo/client';
import { GET_ALL_ROOMS, SUBSCRIBE_TO_ROOMS_UPDATED } from 'graphql/service';
import ActiveMapLegend from 'assets/icons/activeMapLegend.svg'
import MapLegend from 'assets/icons/mapLegend.svg'
import { Container, Header, ViewLegend, MapRow, FloorCardContainer } from './style';
import colors from 'constants/colors'
import { debouncedErrorMessage } from 'utils/messageUtil'

const ManageRooms = () => {

  const dispatch = useDispatch()
  const [isLegendVisible, setIsLegendVisible] = useState(false)
  const [eighthFloorRooms, setEighthFloorRooms] = useState({})
  const [ninthFloorRooms, setNinthFloorRooms] = useState({})
  const [tenthFloorRooms, setTenthFloorRooms] = useState({})
  const checkOutConfirmInfo = useSelector(
    (state) => state.checkOutConfirmInfoReducer
  );

  const {
    loading,
    data: roomsData,
    error,
    subscribeToMore,
  } = useQuery(GET_ALL_ROOMS, {
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
    onCompleted: (roomsData) => {
      let newEighthFloorRooms = {};
      let newNinthFloorRooms = {};
      let newTenthFloorRooms = {};
      roomsData.validRooms.forEach((room) => {
        switch (room.floor) {
          case "8":
            newEighthFloorRooms[room.roomNumber] = room;
            break;
          case "9":
            newNinthFloorRooms[room.roomNumber] = room;
            break;
          case "10":
            newTenthFloorRooms[room.roomNumber] = room;
            break;
          default:
            break;
        }
      });
      setEighthFloorRooms(newEighthFloorRooms);
      setNinthFloorRooms(newNinthFloorRooms);
      setTenthFloorRooms(newTenthFloorRooms);
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(
            error.graphQLErrors[0]?.extensions?.exception
          );
        }
        debouncedErrorMessage(content);
      }
    },
  });

  useEffect(() => {
    // This assumes you want to wait to start the subscription
    // after the query has loaded.
    if (roomsData) {
      const unsubscribe = subscribeToMore({
        document: SUBSCRIBE_TO_ROOMS_UPDATED,
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data?.roomMapUpdated) return;
          const updatedRooms = subscriptionData.data?.roomMapUpdated;

          const mergedRooms = prev.validRooms.map((room) => {
            const updated = updatedRooms.find(
              (element) => element.roomId === room.roomId
            );
            return updated ? updated : room;
          });
          if (
            prev.validRooms?.some(
              (room) => room.roomId === updatedRooms.alertId
            )
          ) {
            return prev;
          }
          return {
            ...prev,
            validRooms: [...mergedRooms],
          };
        },
      });

      return () => {
        unsubscribe();
      };
    }
  }, [roomsData, subscribeToMore]);
    
  if (loading) return <Spinner />;
  if (error) return <p>Error! {error.message}</p>;

  return (
    <Container>
      <Header>
        <ViewLegend
          onClick={() => setIsLegendVisible(!isLegendVisible)}
          active={isLegendVisible}
        >
          {isLegendVisible ?
            <img src={ActiveMapLegend} alt={'activeMapLegend'} /> :
            <img src={MapLegend} alt={'mapLegend'} />}
          <div>{isLegendVisible ? 'HIDE LEGEND' : 'VIEW LEGEND'}</div>
        </ViewLegend>
      </Header>
      { isLegendVisible? <Legend desktop/> : null}
      <MapRow>
        <EighthFloor scale={1.25} backgroundColor={colors.black1} rooms={eighthFloorRooms} />
        <NinthFloor scale={1.25} backgroundColor={colors.black1} rooms={ninthFloorRooms} />
        <TenthFloor scale={1.25} backgroundColor={colors.black1} rooms={tenthFloorRooms} />
      </MapRow>
      <FloorCardContainer>
        <FloorCard
          eighthFloorRooms={eighthFloorRooms}
          ninthFloorRooms={ninthFloorRooms}
          tenthFloorRooms={tenthFloorRooms}
        />
      </FloorCardContainer>
      <ModalCheckOutConfirm
        isOpen={checkOutConfirmInfo.checkOutConfirmIsOpen}
        setIsOpen={(e) => dispatch(setCheckOutConfirmIsOpen(e))}
        roomString={"room " + checkOutConfirmInfo.roomNumber}
        checkOutBookings={checkOutConfirmInfo.checkOutBookings}
      />
    </Container>
  );
};

export default ManageRooms;
